import React, { useContext, useEffect, useState } from 'react';
import { back } from '../../helpers/dataServer';
import ItemUsuarioCliente from './ItemUsuarioCliente';
import { UserContext } from '../auth/context/UserContext';
import '../css/GestionPerfiles.css';

export const RelacionClienteUsuario = () => {
  const [usuarios, setUsuarios] = useState([]);
  const { dataUser } = useContext(UserContext);
  const { token } = dataUser;

  useEffect(() => {
    fetch(`${back}/usuarioclientes/`, {
      headers: {
        Authorization: token,
        'Content-Type': 'application/json',
        method: 'GET',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.data && Array.isArray(data.data)) {
          setUsuarios(data.data);
        } else {
          setUsuarios([]);
          console.error(
            'Error: La API no devolvió una lista válida de usuarios',
            data
          );
        }
      })

      .catch((error) => {
        console.error('Error al obtener la lista de usuarios:', error);
        setUsuarios([]);
      });
  }, [token]);

  return (
    <div className="GrandContainerGestionP">
      <h1>Asignación de Clientes a Usuarios</h1>
      <div className="contenedortabla">
        {Array.isArray(usuarios) && usuarios.length > 0 ? (
          usuarios.map((usuario) => (
            <ItemUsuarioCliente key={usuario.id} usuario={usuario} />
          ))
        ) : (
          <p>No hay usuarios disponibles.</p>
        )}
      </div>
    </div>
  );
};
